import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string;
}

const BrandCoreTrailTab: React.FC<Props> = ({ entityId }) => {
  return (
    <TrailTable entityType="footerBrandCore" entityId={Number(entityId)} />
  );
};

export default BrandCoreTrailTab;
